import { render, staticRenderFns } from "./JapaneseApply.vue?vue&type=template&id=3a484a76"
import script from "./JapaneseApply.vue?vue&type=script&lang=js"
export * from "./JapaneseApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports